import { render } from "./index.vue?vue&type=template&id=3d8bf154&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3d8bf154&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8bf154"]])

export default __exports__